import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      //Test Preparation
      [`${prefix}.Preparation.TareId`]: `Tare ID`,
      [`${prefix}.Preparation.TareMass`]: `Tare Mass`,
      [`${prefix}.Preparation.TareAndSampleMass`]: `Tare and Sample Mass`,
      [`${prefix}.Preparation.Balance`]: `Balance`,
      [`${prefix}.Preparation.PreparedSampleMass`]: `Prepared Sample Mass`,
      [`${prefix}.Preparation.CuringStartedAtDateTime`]: `Curing Started`,
      [`${prefix}.Preparation.CuringCompletedAtDateTime`]: `Curing Finished`,
      [`${prefix}.Preparation.CuringTime`]: `Curing Time`,
      [`${prefix}.Preparation.MoistureConditionTestMethod`]: `Method`,
      [`${prefix}.Preparation.NumberOfBlows`]: `Number of Blows`,
      [`${prefix}.Preparation.ConePenetration`]: `Penetration`,
      [`${prefix}.Preparation.Measure`]: `Steel Rule`,
      [`${prefix}.Preparation.Caliper`]: `Calliper`,
      [`${prefix}.Preparation.ShrinkageMould`]: `Shrinkage Mould`,
      [`${prefix}.Preparation.InternalLengthOfMould`]: `Internal Length of Mould`,
      [`${prefix}.Preparation.DryingStartedAtDateTime`]: `Drying Started`,
      [`${prefix}.Preparation.DryingCompletedAtDateTime`]: `Drying Finished`,
      [`${prefix}.Preparation.InitialDryingTime`]: `Initial Drying Time`,
      [`${prefix}.Preparation.FinalDryingMethod`]: `Final Drying`,
      [`${prefix}.Preparation.Oven`]: `Oven`,
      [`${prefix}.Preparation.OvenTemperature`]: `Oven Temperature`,
      [`${prefix}.Preparation.ShrinkageCeased`]: `Shrinkage ceased`,
      [`${prefix}.Preparation.ColourChangeObserved`]: `Distinct colour change observed`,

      //Sample Preparation
      [`${prefix}.SamplePreparation.PercentPassing`]: `Result`,
      [`${prefix}.SamplePreparation.SampleHistory`]: `Sample History`,
      [`${prefix}.SamplePreparation.PreparationMethod`]: `Preparation History`,
      [`${prefix}.SamplePreparation.MaterialDriedBy`]: `Material Dried By`,
      [`${prefix}.SamplePreparation.PreparationProcessingMethod`]: `Oversize Material Removed By`,
      [`${prefix}.SamplePreparation.GuardSieves[0]`]: `Guard Sieve 1`,
      [`${prefix}.SamplePreparation.OversizeSieve`]: `425 µm Sieve`,
      [`${prefix}.SamplePreparation.WashingSieve`]: `425 µm Washing Sieve`,
      [`${prefix}.SamplePreparation.SeparationSieve`]: `2.36 mm Sieve`,
      [`${prefix}.SamplePreparation.SampleOven`]: `Preparation Oven`,
      [`${prefix}.SamplePreparation.DryingTemperature`]: `Drying Temperature`,
      [`${prefix}.SamplePreparation.WashingMethod`]: `Washing Method`,
      [`${prefix}.SamplePreparation.MaterialConditionAsTested`]: `Material Condition As Tested`,
      [`${prefix}.SamplePreparation.AssociatedPercentagePassing.ExternalTest.Results.PercentagePassing_425_Sieve`]: `Result`,

      //Measurements
      [`${prefix}.Measurements.Curling`]: `Curling`,
      [`${prefix}.Measurements.Crumbling`]: `Crumbling`,
      [`${prefix}.Measurements.Cracking`]: `Cracking`,
      [`${prefix}.Measurements.UnableToMeasure`]: `Unable to measure`,
      [`${prefix}.Measurements.TopSurfaceLength`]: `Top Surface Length`,
      [`${prefix}.Measurements.BottomSurfaceLength`]: `Bottom Surface Length`,
      [`${prefix}.Measurements.SoilBarLength`]: `Soil Bar Length`,
      [`${prefix}.Measurements.LongitudinalShrinkage`]: `Longitudinal Shrinkage`,
      [`${prefix}.Measurements.LongitudinalShrinkageText`]: `Longitudinal Shrinkage`,
      [`${prefix}.Measurements.LinearShrinkage`]: `Linear Shrinkage`,
      [`${prefix}.Measurements.LinearShrinkageText`]: `Linear Shrinkage`,
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.SamplePreparation.PercentPassing`]: '%',
      [`${prefix}.SamplePreparation.AssociatedPercentagePassing.ExternalTest.Results.PercentagePassing_425_Sieve`]: '%',
      [`${prefix}.Measurements.LinearShrinkage`]: '%',
    })
  );

export default getLabelConfig;
